import { render } from "./RatingModal.vue?vue&type=template&id=5d9562f5&ts=true"
import script from "./RatingModal.vue?vue&type=script&lang=ts"
export * from "./RatingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__